import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { CalendarFooterButtonModule } from '../calendar-footer-button/calendar-footer-button.module';
import { CalendarFooterButtonComponent } from '../calendar-footer-button/calendar-footer-button.component';

@Component({
    standalone: true,
    selector: 'time-constraint-calendar-footer',
    template: '<ng-template #templateRef><calendar-footer-button [comp]="calendarComponent"></calendar-footer-button></ng-template>',
    imports: [
        CalendarFooterButtonModule,
    ],
})
export class TimeConstraintCalendarFooterComponent {
    @Input() calendarComponent: Calendar;

    @ViewChild('templateRef', { static: true }) public templateRef: TemplateRef<CalendarFooterButtonComponent>;
}
